import Vue from 'vue'
import VueCookies from 'vue-cookies'
import authorizeConstants from '../../constants/authorizeConstants'
Vue.use(VueCookies)

const authorization = {
  mutations: {
    deleteAccessToken: function (state) {
      const accessTokenKey = authorizeConstants.ACCESS_TOKEN_KEY
      Vue.cookies.remove(accessTokenKey)
    }
  },
  actions: {
    loadAuthorization: function (context) {
      return new Promise((resolve, reject) => {
        const accessTokenKey = authorizeConstants.ACCESS_TOKEN_KEY
        const accessToken = Vue.cookies.get(accessTokenKey)
        if (accessToken) {
          resolve(accessToken)
        } else {
          const refreshTokenKey = authorizeConstants.REFRESH_TOKEN_KEY
          const refreshToken = Vue.cookies.get(refreshTokenKey)
          if (refreshToken) {
            Vue.prototype.$ajax({
              url: '/index/m/ws/login/refreshToken',
              method: 'post',
              data: Vue.prototype.$qs.stringify({
                refreshToken: refreshToken
              })
            }).then(result => {
              const refreshAccessToken = Vue.cookies.get(accessTokenKey)
              if (refreshAccessToken) {
                resolve(refreshAccessToken)
              } else {
                reject(new Error(authorizeConstants.ERROR_TYPE.REFRESH_TOKEN_FAULT))
              }
            }, () => {
              reject(new Error(authorizeConstants.ERROR_TYPE.SERVER_ERROR))
            })
          } else {
            reject(new Error(authorizeConstants.ERROR_TYPE.NONE_REFRESH_TOKEN))
          }
        }
      })
    }
  }
}

export default authorization



// WEBPACK FOOTER //
// ./src/store/modules/authorization.js